<template>
  <div class="contact-app container_ inner-app">
    <!-- <nav class="flex align-center gap5">
      <router-link :to="{name: 'ExamplePage'}">{{$t('examples')}}</router-link>
    </nav> -->
    <ContactPage class="inner-app-content"/>
    <transition name="modal-fade">
      <Modal v-if="isModalRoute" @close="closeModal" :showCloseBtn="true" :fullScreen="true">
        <router-view />
      </Modal>
    </transition>
    <Loader v-if="isLoading && false"/>
  </div>
</template>

<script>
import Loader from '@/apps/common/modules/common/cmps/Loader.vue'
import Modal from '@/apps/common/modules/common/cmps/Modal.vue'
import ContactPage from './views/ContactPage.vue'

export default {
  name: 'ContactApp',
  computed: {
    isLoading() {
      return this.$store.getters['contact/isLoading']
    },
    isModalRoute() {
      return this.$route.meta.isModal
    }
  },
  methods: {
    closeModal() {
      this.$router.push({ name: 'ContactPage', params: { organizationId: this.$route.params.organizationId } })
    }
  },
  components: {
    Loader,
    Modal,
    ContactPage
  }
}
</script>

<style lang="scss">
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.2s;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}
</style>